"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.span = void 0;
function span(tree) {
    switch (tree.kind) {
        case "Tree.node": {
            return tree.span;
        }
        case "Tree.leaf": {
            const { token } = tree;
            return token.span;
        }
    }
}
exports.span = span;
//# sourceMappingURL=tree-span.js.map